import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import baseStyles from '../styles';
import { composeValidators, email, required, phone } from '../Form/validators';

import { Form } from 'formik';
import { TextField } from '../Form/shared';
import { withTranslation } from 'react-i18next';

class ContactForm extends Component {
  render() {
    const { classes, errors, touched, t } = this.props;
    return (
      <Form className={classes.form}>
        <TextField
          label={t('Name')}
          name="name"
          validate={required}
          highlight={false}
          error={touched.name && errors.name}
        />
        <TextField
          label={t('Phone')}
          type="tel"
          name="phone"
          margin="normal"
          validate={composeValidators([required, phone])}
          highlight={false}
          error={touched.phone && errors.phone}
        />
        <TextField
          label={t('Company')}
          name="company"
          margin="normal"
          highlight={false}
          error={touched.company && errors.company}
        />
        <TextField
          label={t('Designation')}
          name="position"
          margin="normal"
          highlight={false}
          error={touched.position && errors.position}
        />
        <TextField
          label={t('Email')}
          type="email"
          name="email"
          margin="normal"
          validate={email}
          highlight={false}
          error={touched.email && errors.email}
        />
      </Form>
    );
  }
}

const styles = theme => {
  const base = baseStyles(theme);
  return {
    form: {
      ...base.flexColumn,
      padding: theme.spacing(),
    },
  };
};

export default withTranslation()(withStyles(styles)(ContactForm));
